import {
  projectMapsKeys,
  RequestTypes,
} from '@core/react-query/features/projects/maps'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useDeleteProjectMapLayer = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['deleteProjectMapLayer']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectMapsKeys.deleteProjectMapLayer,
    ...options,
    retry: 0,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(
        projectMapsKeys.byProjectMapConfiguration({
          projectId: variables.projectId,
        }),
      )
    },
  })
}
